import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { gsap } from "gsap/all"
import TransitionLink from "gatsby-plugin-transition-link"
import { up, down } from "styled-breakpoints"
import { Link } from "gatsby"
import Button from "../atomic/atoms/input/button"

import { TYPE, COLORS } from "../../theme/styles/globals"

export default class Menu extends React.Component {

  state = {
    open: false
  }

  rowOne = React.createRef()
  rowTwo = React.createRef()
  rowThree = React.createRef()

  componentDidMount() {
    gsap.set(".footer-link-1, .footer-link-2", { y:-60 })
    //gsap.set(".contact", { width: 0, autoAlpha:0 })
    gsap.set(".contact a div span", { color: '#000'})
  }

  open = () => {

    const w = window.innerWidth

    gsap.to(".menu-block-1", { duration: .7, width: w, ease: "expo.easeOut", delay: 0 })
    gsap.to(".menu-block-2", { duration: .3, width: w, ease: "expo.easeOut", delay: 0.3 })
    gsap.to(".menu-block-3", { duration: .3, width: w, ease: "expo.easeOut", delay: 0.1 })
    gsap.to(".menu-block-4", { duration: .5, width: w, ease: "expo.easeOut", delay: 0.5 })
    gsap.to(".menu-block-5", { duration: .4, width: w, ease: "expo.easeOut", delay: 0.1 })

    gsap.to(".menu-item-1", { duration: .4, height: 'auto', opacity: 1, ease: "expo.easeOut", delay: 0.7 })
    gsap.to(".menu-item-2", { duration: .4, height: 'auto', opacity: 1, ease: "expo.easeOut", delay: 0.8 })
    gsap.to(".menu-item-3", { duration: .4, height: 'auto', opacity: 1, ease: "expo.easeOut", delay: 0.9 })
    gsap.to(".footer-link-1", { duration: .4, y: 0, ease: "expo.easeOut", delay: 1 })
    gsap.to(".footer-link-2", { duration: .4, y: 0, ease: "expo.easeOut", delay: 1 })

    gsap.to(".contact", { duration: .4, width: 192, autoAlpha:1, ease: "expo.easeOut", delay: 1 })

    this.setState({ open:true })
    
  }
  
  close = () => {

    gsap.to(".menu-item-1", { duration: .4, height: 0, opacity: 1, ease: "expo.easeOut", delay: 0.1 })
    gsap.to(".menu-item-2", { duration: .4, height: 0, opacity: 1, ease: "expo.easeOut", delay: 0.2 })
    gsap.to(".menu-item-3", { duration: .4, height: 0, opacity: 1, ease: "expo.easeOut", delay: 0.3 })
    
    gsap.to(".menu-block-1", { duration: .7, width: 0, ease: "expo.easeOut", delay: 0.8 })
    gsap.to(".menu-block-2", { duration: .3, width: 0, ease: "expo.easeOut", delay: 0.7 })
    gsap.to(".menu-block-3", { duration: .3, width: 0, ease: "expo.easeOut", delay: 0.5 })
    gsap.to(".menu-block-4", { duration: .5, width: 0, ease: "expo.easeOut", delay: 0.9 })
    gsap.to(".menu-block-5", { duration: .4, width: 0, ease: "expo.easeOut", delay: 0.4 })

    gsap.to(".footer-link-1", { duration: .4, y: -60, ease: "expo.easeOut", delay: 0.4 })
    gsap.to(".footer-link-2", { duration: .4, y: -60, ease: "expo.easeOut", delay: 0.4 })

    gsap.to(".contact", { duration: .4, width: 0, autoAlpha:0, ease: "expo.easeOut", delay: 0.3 })

    this.setState({ open:false })

  }

  mouseOver = () => {
    gsap.to(this.rowOne.current , { width: 45, duration:.4, ease: "expo.out", onStart: () => gsap.set(this.rowOne.current, {display:"flex"}) })
    gsap.to(this.rowTwo.current , { width: 45, duration:.4, delay:.1, ease: "expo.out", onStart: () => gsap.set(this.rowTwo.current, {display:"flex"}) })
    gsap.to(this.rowThree.current , { width: 45, duration:.4, delay:.2, ease: "expo.out", onStart: () => gsap.set(this.rowThree.current, {display:"flex"}) })
  }
  
  mouseOut = () => {
    gsap.to(this.rowOne.current , { width: 0, duration:.4, ease: "expo.out", onComplete: () => gsap.set(this.rowOne.current, {display:"none"}) })
    gsap.to(this.rowTwo.current , { width: 0, duration:.4, delay:.1, ease: "expo.out", onComplete: () => gsap.set(this.rowTwo.current, {display:"none"}) })
    gsap.to(this.rowThree.current , { width: 0, duration:.4, delay:.2, ease: "expo.out", onComplete: () => gsap.set(this.rowThree.current, {display:"none"}) })
  }

  render(){

    const { transition } = this.props

    return(
      <Container>
        <TransitionLink to="/" exit={transition.exit} entry={transition.entry}>
          {/* <Logo viewBox="0 0 60 60">
              <path
                d="M30 0C13.4 0 0 13.4 0 30s13.4 30 30 30 30-13.4 30-30S46.6 0 30 0zm.1 13.4c.6 0 1.3.1 1.9.2l-9.6 21c-2.6-2.2-4.2-5.5-4.2-9.2 0-6.6 5.3-12 11.9-12zm-1.9 33.7c-5.5-.9-9.8-5.6-10-11.4h10v11.4zm1.9.1c-.6 0-1.3-.1-1.9-.2l9.6-21c2.6 2.2 4.2 5.5 4.2 9.2 0 6.6-5.3 12-11.9 12zM32 25V13.6c5.5.9 9.8 5.6 10 11.4H32z"
                fill={COLORS.DARK_GREY_2}
              />
              <defs>
                <path
                  id="prefix__a"
                  d="M32 13.5c5.5.9 9.8 5.6 10 11.4H32V13.5zm-1.9-.1c.6 0 1.3.1 1.9.2l-9.6 21c-2.6-2.2-4.2-5.5-4.2-9.2 0-6.6 5.3-12 11.9-12zm-1.9 22.2V47c-5.5-.9-9.8-5.6-10-11.4h10zm9.6-9.5c2.6 2.2 4.2 5.5 4.2 9.2 0 6.6-5.3 12-11.9 12-.6 0-1.3-.1-1.9-.2l9.6-21z"
                  fill={COLORS.WHITE}
                />
              </defs>
              <use
                xlinkHref="#prefix__a"
                overflow="visible"
                fillRule="evenodd"
                clipRule="evenodd"
              />
          </Logo> */}
          <Logo xmlns="http://www.w3.org/2000/svg" viewBox="0 0 169.38 169.38">
            <g id="Layer_2" data-name="Layer 2">
              <g id="Layer_1-2" data-name="Layer 1">
                <circle cx="84.69" cy="84.69" r="84.69" fill="#181616"/>
                <path fill="#fff" d="M50.81 100.86a34.67 34.67 0 0 0 29 33v-33Z"/>
                <path fill="#fff" d="m107.8 73.15-27.88 60.71a34.64 34.64 0 0 0 40.21-34.22 34.56 34.56 0 0 0-12.33-26.49Z"/>
                <path fill="#fff" d="M120.13 70a34.67 34.67 0 0 0-29-33v33Z"/>
                <path fill="#fff" d="M63.14 97.71 91 37a34.64 34.64 0 0 0-40.19 34.22 34.56 34.56 0 0 0 12.33 26.49Z"/>
                <path fill="#fff" d="M120.61 39.54h-1v1.53h1c.69 0 .86-.34.86-.78s-.25-.75-.86-.75m.82 4.18-.81-1.85h-1v1.83h-.88v-5h1.83a1.58 1.58 0 0 1 1.75 1.57 1.41 1.41 0 0 1-.87 1.42l.9 2Zm-1-6.26a3.84 3.84 0 1 0 3.78 3.83 3.81 3.81 0 0 0-3.78-3.83m0 8.58a4.75 4.75 0 1 1 4.7-4.75 4.71 4.71 0 0 1-4.7 4.75"/>
              </g>
            </g>
          </Logo>
        </TransitionLink>
        <Icon 
          onMouseEnter={this.mouseOver} 
          onMouseLeave={this.mouseOut}
          onClick={() => this.state.open ? this.close() : this.open()}
        >
          <Row>
            <Dot />
            <Dot />
            <Dot />
            <DotRow ref={this.rowOne} />
          </Row>
          <Row>
            <Dot />
            <Dot />
            <Dot />
            <DotRow ref={this.rowTwo} />
          </Row>
          <Row>
            <Dot />
            <Dot />
            <Dot />
            <DotRow ref={this.rowThree} />
          </Row>
        </Icon>
        <MenuContainer>
          <MenuItems>
            <MenuItem className="menu-item-1">
              <MenuItemPrefix>01</MenuItemPrefix>
              <TransitionLink to="/" exit={transition.exit} entry={transition.entry}><p>Home</p></TransitionLink>
            </MenuItem>
            <MenuItem className="menu-item-2">
              <MenuItemPrefix>02</MenuItemPrefix>
              <TransitionLink to="/about" exit={transition.exit} entry={transition.entry}><p>About</p></TransitionLink>
            </MenuItem>
            <MenuItem className="menu-item-3">
              <MenuItemPrefix>03</MenuItemPrefix>
              <TransitionLink to="/projects" exit={transition.exit} entry={transition.entry}><p>Projects</p></TransitionLink>
            </MenuItem>
          </MenuItems>
          <Contact className="contact">
              <Button action="EXTERNAL" label="Let's chat" mode="MENU" link="tel:0290992544" transition={transition}></Button>
              <Button action="EXTERNAL" label="Email us" mode="MENU" link="mailto:hello@slik.com.au" transition={transition}></Button>
          </Contact>
          <Footer>
              <FooterItemLeft className="footer-link-1">
                  <FooterLink href="mailto:hello@slik.com.au" target="_blank">hello@slik.com.au</FooterLink>
                  <br />
                  <FooterLink href="tel:0290992544" target="_blank">02 9099 2544</FooterLink>
              </FooterItemLeft>
              <FooterItemRight className="footer-link-2">LEVEL 1, 91 CAMPBELL ST SURRY HILLS, 2010 AUSTRALIA</FooterItemRight>
          </Footer>
          <Loop id="loop">
            {/* <Video
              autoPlay
              loop
              muted
              playsinline
            >
              <source src="//videos.ctfassets.net/zysgo1161a3j/7aOpUF1fuB9v0QOdwYiSZk/46d783ec3300845de362f302b991fc55/Slik_Menu_Logo_1080x1080_v1.mp4" type="video/mp4" />
            </Video> */}
          </Loop>
          <Ribbon style={{ top:'0' }} className="menu-block-1" />
          <Ribbon style={{ top:'20vh' }} className="menu-block-2" />
          <Ribbon style={{ top:'40vh' }} className="menu-block-3" />
          <Ribbon style={{ top:'60vh' }} className="menu-block-4" />
          <Ribbon style={{ top:'80vh' }} className="menu-block-5" />
        </MenuContainer>
      </Container>
    )

  }

}


const Logo = styled.svg`
  position: fixed;
  z-index: 1000;
  width: 60px;
  top: 20px;
  left: 30px;
  z-index:4002;
  pointer-events:all;
`

const Container = styled.div`
  display:flex;
  width:100%;
  height:100%;
  position:fixed;
  top:0px;
  left:0px;
  right:0px;
  bottom:0px;
  z-index:8000;
  pointer-events:none;
`

const Icon = styled.div`
  width:37px;
  height:37px;
  position:fixed;
  z-index:4001;
  top:32px;
  right:28px;
  align-items:center;
  flex-direction:column;
  pointer-events:all;
  background:rgba(0,0,0,0);
  cursor:pointer;

  ${up('md')}{
    top:30px;
  }
`

const Row = styled.div`
  align-items: center;
  width: 100%;
  height:100%;
  justify-content:space-between;
  flex-direction:row;
  display:flex;
  position: relative;
  height:2px;
  margin-bottom:16px;
`
const DotRow = styled.div`
  width:0px;
  height:3px;
  background:white; 
  position:absolute;
  left:0;
  top:0;
  border:1px solid #BBBBBB;
  display:none;
`

const Dot = styled.div`
  width:3px;
  height:3px;
  background:white;
  border:1px solid #BBBBBB;
`

const MenuContainer = styled.div`
  position:absolute;
  width:100%;
  height:100vh;
  top:0px;
  left:0px;
  z-index:4000;
  overflow-x:hidden;
`

const Ribbon = styled.div`
  background-color:#f9f8f9;
  display:block;
  height:20vh;
  width:0px;
  position:absolute;
  left:0;
`

const MenuItems = styled.div`
  position:absolute;
  width:100%;
  top:0px;
  left:10%;
  height:100vh;
  display:flex;
  flex-direction:column;
  align-items:space-between;
  z-index:4003;
  overflow:hidden;
  padding-top:25vh;
  padding-bottom:30vh;
  ${down("xs")} {
    padding-top:19vh;
  }
`

const MenuItem = styled.div`
  flex-grow:1;
  display:flex;
  justify-content:flex-start;
  align-items:center;
  margin:0;
  padding:0;
  opacity:0;
  height:0;
  overflow-y:hidden;
  pointer-events:all;
  position: absolute;

  :nth-child(2) {
      margin-top:15vh;
    }
    :nth-child(3) {
      margin-top:30vh;
    }

  a{
    color:black;
  }

  p{
    font-family:${TYPE.SERIF_BOLD_FONT};
    font-size:9vh;
  }

  ${down("xs")} {
    p {
      font-size:8vh;
    }
    :nth-child(2) {
      margin-top:13vh;
    }
    :nth-child(3) {
      margin-top:26vh;
    }
  }
  
`

const MenuItemPrefix = styled.span`
  font-family:${TYPE.MONO_FONT};
  font-size: 10px;
  position: absolute;
  top: 0px;
  left: 0px;
  color: black;
  z-index:4004;
`

const Loop = styled.div`
  position:absolute;
  top:50%;
  right:30vh;
  margin-top:-25vh;
  width:60vh;
  height:60vh;
  z-index:8000;
`

const Video = styled.video`
  width:100%;
  height:100%;
  position:absolute;

`

const Footer = styled.div`
  width: 90%;
  height: 100px;
  position: absolute;
  left:10%;
  bottom:0;
  z-index:4100;
  display: flex;
  overflow: hidden;
  ${down("xs")} {
    height:15vh;
  }
`

const FooterItem = styled.div`
  font-family:${TYPE.MONO_FONT};
  font-size: 12px;
  font-size:1.4vh;
  line-height: 2.8vh;
  color: #000;
  padding-right: 40px;
  width:22em;
  ${down("xs")} {
    width:100%;
    font-size:9px;
    padding-right: 20px;
  }
`

const FooterItemLeft = styled(FooterItem)`
${down("xs")} {
    display:none;
  }
`

const FooterItemRight = styled(FooterItem)`
`

const FooterLink = styled.a`
  cursor: pointer;
  pointer-events: visible;
  text-decoration: none;
  color:#000;
`

const Contact = styled.div`
  width: 0px;
  height: 120px;
  position: absolute;
  left:10%;
  bottom:100px;
  z-index:4100;
  overflow: hidden;
  pointer-events: visible;
  display:none;
  flex-direction: column;
  justify-content: space-between;
  ${down("xs")} {
    display:flex;
    bottom:21vh;
  }
`